import React from 'react'
import imgCircle from '../../assets/imgs/user/personCircle.svg'
import { env } from '../../utils/constants/env-vars'
import './photoCircle.scss'

const PhotoCircle = ({ image }) => {
  return (
    <div className="size-img-circle">
      <img
        className="imgCircle"
        src={image ? env.URL_IMG + image : imgCircle}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = imgCircle
        }}
        alt="user"
      />
    </div>
  )
}

export default PhotoCircle
